module.exports = __webpack_public_path__ + "img/563d40b.png";